function Three() {
    return (
        <div className="flex w-full bg-[#f9f9f9] p-2 rounded-sm items-center flex-col md:flex-row" id='promise3'> {/* Added bg-gray-100 for a light gray background */}
            <div className="benefits-details w-full md:w-7/12 p-4"> {/* Added padding for better content spacing */}
                <h2 className="text-lg md:text-xl font-bold mb-6 mt-4 text-black leading-tight inline-block relative">
                    <span className="relative z-10">96-Hour Fare Hold — <span className="text-green-600">Free!</span></span>
                    <span className="absolute -bottom-2 left-0 h-1 rounded-md w-[50%] bg-gradient-custom -z-0"></span>
                </h2>

                <p className="text-sm text-black mb-4">Love a holiday deal but need time to finalize your plans? We totally understand. Our <span className="text-halo-pink">96-Hour Fare Hold</span> gives you the flexibility to hold your favorite package and lock in the price—for free! Go ahead and take that extra time to confirm with family or friends, check dates, or book time off work.</p>

                <p className="text-sm text-black mb-4">We believe every booking should feel just right, and we’re here to help you make the best choice with zero rush.</p>

                <h3 className="text-lg font-semibold mb-4 mt-4">Why You'll Love This</h3>
                <ul className="custom-bullet pl-5 space-y-2 text-black text-sm">
                    <li><span className="font-medium text-black">No Pressure to Decide</span> – Hold your preferred booking while you make your final arrangements.</li>
                    <li><span className="font-medium text-black">Price Lock Guarantee</span> – Secure today’s price, even if fares go up later.</li>
                    <li><span className="font-medium text-black">Free to Use</span> – No cost, no commitment—just a thoughtful way to ease your decision-making.</li>
                </ul>

                <div className="bg-white rounded-lg p-4 mt-4"> {/* New container with background */}
                    <div className="flex items-center">
                        <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-6 h-6 mr-2" />
                        <h3 className="text-lg font-semibold">Our Promise</h3>
                    </div>
                    <p className="text-black mt-2">Holiday planning shouldn’t feel rushed. With our 96-hour fare hold, you can explore your options and book only when you’re ready!</p>
                </div>
            </div>
            <div className="benefits-divider w-1/12 bg-gray-300 min-h-full"></div> {/* Ensured divider reaches full height */}
            <div className="hidden md:block w-full md:w-4/12"> {/* Added full width for consistency */}
                <div className="promise-image-column w-full p-4">
                    <img src="/halo-promise/3.png" alt="24/7 Toll-Free Holiday Hotline" className="w-full h-auto object-contain" />
                </div>
            </div>
        </div>
    );
}

export default Three;